var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShippingBillingOutletForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.5,
    height: 36.5,
    viewBox: "0 0 36.5 36.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63259",
    "data-name": "Group 63259",
    transform: "translate(-620.75 -348.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1740",
    "data-name": "Ellipse 1740",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(621 349)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63265",
    "data-name": "Group 63265",
    transform: "translate(631.914 359.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221852",
    "data-name": "Path 221852",
    d: "M11.972,4.062V.458A.458.458,0,0,0,11.514,0H8.424V3.48a.457.457,0,0,1-.693.392L6.236,3.116l-1.525.772a.458.458,0,0,1-.662-.408V0H.958A.458.458,0,0,0,.5.458V11.014a.458.458,0,0,0,.458.458H6.925a6.218,6.218,0,0,1-.448-2.134A5.281,5.281,0,0,1,11.972,4.062Zm0,0",
    transform: "translate(-0.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221853",
    "data-name": "Path 221853",
    d: "M148.24,2.2l1.067.54V0h-2.545V2.737l1.066-.54A.456.456,0,0,1,148.24,2.2Zm0,0",
    transform: "translate(-142.298)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221854",
    "data-name": "Path 221854",
    d: "M230.708,162.965a4.365,4.365,0,0,0-4.365,4.365,7.927,7.927,0,0,0,1.484,3.912c.894,1.334,2.038,2.375,2.881,2.375s1.987-1.041,2.881-2.375a7.927,7.927,0,0,0,1.484-3.912A4.365,4.365,0,0,0,230.708,162.965Zm0,6.045a1.68,1.68,0,1,1,1.68-1.68A1.68,1.68,0,0,1,230.708,169.009Zm0,0",
    transform: "translate(-219.452 -157.992)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingBillingOutletForm);
export default __webpack_public_path__ + "static/media/shippingBillingOutletForm.7a4dd5db1abb9fae4185eefc12dd9cc8.svg";
export { ForwardRef as ReactComponent };